import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  createLegalEntityAddress,
  updateLegalEntityAddress,
} from '../store/actions/person/personActions';
import useApplicationUid from './useApplicationUid';

const useLegalEntityAddressDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const legalEntityAddressDispatch = ({
    data,
    personUid,
    defaultValues,
    onSuccess,
    onError,
  }) => {
    const shouldSkip = isEqual(data, defaultValues);

    if (shouldSkip) {
      onSuccess();
      return;
    }

    const requestData = {
      ApplicationUid,
      PersonUid: personUid,
      data,
      onSuccess,
      onError,
    };

    if (defaultValues?.Street) {
      dispatch(
        updateLegalEntityAddress({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createLegalEntityAddress({
        ...requestData,
      }),
    );
  };

  return { legalEntityAddressDispatch };
};

export default useLegalEntityAddressDispatch;
